const ERRORS = {
  SOMETHING_WENT_WRONG: 'Something went wrong',
};

export default ERRORS;
